import React from "react";
import { useNavigate } from "react-router-dom";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";

/* comp imports */
import BackArrow from "../components/BackArrow";
import PageTransition from "../components/PageTransition";
import DisclaimerContentWrapper from "../components/DisclaimerContentWrapper";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

/* Data import */
import {
  mainDisclaimerHeaderContent,
  mainDisclaimerDataContent,
} from "../data/mainDisclaimerDataContent";

const Disclaimer = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };
  return (
    <>
      <PageTransition />
      <div className="page-main-wrapper disclaimer-page-main-wrapper">
        <BackArrow handleRedirect={handleRedirect} linkName="/" />
        <DisclaimerContentWrapper
          mainDisclaimerDataContent={
            mainDisclaimerDataContent && mainDisclaimerDataContent
          }
          mainDisclaimerHeaderContent={
            mainDisclaimerHeaderContent && mainDisclaimerHeaderContent
          }
        />
        <MainDisclaimerModal />
      </div>
    </>
  );
};

export default Disclaimer;
